<script lang="ts" setup>
import { Slot } from "reka-ui"
import { useFormField } from "./useFormField"

const { error, formItemId, formMessageId } = useFormField()
</script>

<template>
    <Slot
        :id="formItemId"
        :aria-describedby="error ? formMessageId : undefined"
        :aria-invalid="!!error"
    >
        <slot />
    </Slot>
</template>
